<template>
    <div>
        <MenuBar style="position: fixed; z-index: 99; top: 0; left: 0;" v-responsive.lg.xl :pages="pages"/>
        <MenuBar style="visibility: hidden" v-responsive.lg.xl :pages="pages"/>
        <MenuBarResponsive style="position: fixed; z-index: 99; top: 0; left: 0;" v-responsive.sm.xs.md
                           :pages="pages"/>
        <MenuBarResponsive style="visibility: hidden" v-responsive.sm.xs.md :pages="pages"/>
    </div>
</template>

<script>
    import MenuBar from './MenuBarComponent'
    import MenuBarResponsive from './MenuBarResponsive'

    export default {
        name: "MenuFacade",
        components: {MenuBar, MenuBarResponsive},
        props: ['pages']
    }
</script>

<style scoped>

</style>
